import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./assets/variable.scss";
import "./assets/global.scss";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
